import React from "react";
import ReactCountryFlag from "react-country-flag";

interface CountryFlagProps {
    countryCode?: string;
    size?: number;
}

// Renders a country flag from an ISO 3166-1 alpha-2 code via react-country-flag
// (inline SVG, no external image CDN calls) — used next to every IP address
// shown in the admin panel, using the country code the backend resolves from
// that IP via geoip-lite.
const CountryFlag: React.FC<CountryFlagProps> = ({ countryCode, size = 14 }) => {
    if (!countryCode) return null;
    return (
        <ReactCountryFlag
            countryCode={countryCode}
            svg
            style={{ width: `${size}px`, height: `${size}px`, marginRight: "4px", flexShrink: 0 }}
            title={countryCode}
        />
    );
};

export default CountryFlag;
